import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root is missing from index.html');

// We deliberately do NOT call `hydrateRoot` even when `#root` has prerendered
// children. The prerender crawl (web/scripts/prerender.mjs) captures
// CSR-shape DOM via headless Chrome, which lacks the SSR hydration markers
// (Suspense boundaries, etc.) React 18 looks for — so `hydrateRoot` throws
// #418/#423/#425 even when the markup is byte-identical to React's output.
// Crawlers still see the static HTML (which is the whole point of Task
// 0.1); real users get an effectively invisible re-render since the new
// tree matches the prerendered DOM.
//
// HelmetProvider wraps the app so per-route <Seo /> components can inject
// <title>/<meta>/<link>/<script type="application/ld+json"> into <head>.
// The prerender crawl's headless-Chrome capture picks up whatever Helmet
// has flushed to the DOM, so the per-route head tags end up in the static
// HTML.
createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);
